// Keys under `home.faq-section.items`. Shared by the accordion and by the
// FAQPage JSON-LD the home page emits, so both always describe the same set.
//
// `profile` and `listing-rules` were dropped from the home page on 2026-09-23:
// six focused answers read better than eight, and the two removed ones were
// about writing a listing rather than finding a room or a roommate. The keys
// stay in the locale files (other locales still translate them) -- nothing is
// renamed.
const FAQ_ITEMS = [
  'search',
  'price',
  'safe-validate',
  'safety-tips',
  'messages',
  'mobile-app',
] as const;

export default FAQ_ITEMS;
